import { useSelector } from "../store";

export const useIsHostedCluster = (): boolean => {
  const flavor = useSelector((state) => state.current.flavor);

  return flavor === "hosted";
};
